/* Palazzina Wellness – Design-Vorschlag 21.10.2026 (Vorschau-Theme). Effekte ohne Bibliothek:
 * Einblenden (IntersectionObserver), Sticky-Story, Schiene mit Pfeilen, feste Leiste mobil, Lichtkegel auf Kacheln (B),
 * Design-Schalter A/B, Zusatz auf der Produktseite (Angebot für Unternehmen), Kontaktformular #unternehmen vorbefüllen.
 * Respektiert prefers-reduced-motion. Quelle: theme/assets/pwx.js */
(function () {
  'use strict';
  var d = document, de = d.documentElement;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EN = (de.lang || '').toLowerCase().indexOf('en') === 0;
  var IO = 'IntersectionObserver' in window;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  /* ---------- Design-Schalter ---------- */
  function placeHero(v) {
    var m = d.querySelector('[data-x-hero-media]'); if (!m) return;
    $$(':scope > picture', m).forEach(function (p) { p.remove(); });
    var t = m.querySelector('template[data-x-hero-img="' + v + '"]');
    if (t) m.insertBefore(t.content.cloneNode(true), m.querySelector('script') || m.firstChild);
  }
  function setDesign(v) {
    de.setAttribute('data-design', v);
    try { localStorage.setItem('pwx-design', v); } catch (e) {}
    try { var u = new URL(location.href); u.searchParams.set('design', v); history.replaceState(history.state, '', u.toString()); } catch (e) {}
    var tc = d.querySelector('meta[name="theme-color"]'); if (tc) tc.setAttribute('content', v === 'b' ? '#0e0c0a' : '#f5f1ea');
    $$('[data-x-design]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-x-design') === v)); });
    placeHero(v);
  }
  $$('[data-x-design]').forEach(function (b) {
    b.setAttribute('aria-pressed', String(b.getAttribute('data-x-design') === (de.getAttribute('data-design') || 'a')));
    b.addEventListener('click', function () { setDesign(b.getAttribute('data-x-design')); });
  });

  /* ---------- Bilder erst kurz vor dem Sichtbereich laden (kleinerer Vorlauf als loading=lazy -> schnellerer Seitenaufbau mobil) ---------- */
  var lazyLoad = function (i) {
    if (!i.getAttribute('data-x-src')) return;
    i.addEventListener('load', function () { i.classList.add('x-loaded'); }, { once: true });
    var ss = i.getAttribute('data-x-srcset'); if (ss) i.setAttribute('srcset', ss);
    i.setAttribute('src', i.getAttribute('data-x-src')); i.removeAttribute('data-x-src'); i.removeAttribute('data-x-srcset');
    if (i.complete && i.naturalWidth > 1) i.classList.add('x-loaded');
  };
  var lazy = $$('img[data-x-src]');
  lazy.forEach(function (i) { i.setAttribute('data-x-lazy', ''); });
  if (IO) {
    var lo = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { var t = en.target; if (t.hasAttribute('data-x-rail')) $$('img[data-x-src]', t).forEach(lazyLoad); else lazyLoad(t); lo.unobserve(t); } }); }, { rootMargin: '700px 700px' });
    /* Schienen: die ganze Schiene beobachten (Karten rechts sind vom seitlichen Scrollen abgeschnitten und wuerden sonst erst beim Wischen laden) */
    var seen = []; lazy.forEach(function (i) { var r = i.closest('[data-x-rail]'), t = r || i; if (seen.indexOf(t) < 0) { seen.push(t); lo.observe(t); } });
  } else lazy.forEach(lazyLoad);

  /* ---------- Einblenden ---------- */
  function reveal(root) {
    var els = $$('.x-rv:not(.is-in)', root);
    if (!els.length) return;
    if (!IO || RM) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    // Versatz für Geschwister (Kacheln, Karten)
    els.forEach(function (e) { var p = e.parentNode, sib = $$(':scope > .x-rv', p), i = sib.indexOf(e); if (i > 0) e.style.setProperty('--x-d', Math.min(i, 6) * 70 + 'ms'); });
    var o = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); o.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { o.observe(e); });
  }
  reveal(d);

  /* ---------- Story: aktiven Schritt + Bild ---------- */
  $$('[data-x-story]').forEach(function (s) {
    var steps = $$('[data-x-step]', s), figs = $$('[data-x-fig]', s), bar = s.querySelector('[data-x-bar]'), cnt = s.querySelector('[data-x-count]');
    if (!steps.length || !IO) return;
    var set = function (i) {
      steps.forEach(function (st, k) { st.classList.toggle('is-on', k === i); });
      figs.forEach(function (f, k) { f.classList.toggle('is-on', k === i); });
      if (bar) bar.style.height = ((i + 1) / steps.length * 100) + '%';
      if (cnt) cnt.textContent = '0' + (i + 1) + ' / 0' + steps.length;
    };
    var o = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) set(steps.indexOf(en.target)); }); }, { rootMargin: '-48% 0px -48% 0px', threshold: 0 });
    steps.forEach(function (st) { o.observe(st); });
  });

  /* ---------- Schienen (mobil/Tablet) ---------- */
  $$('[data-x-rail]').forEach(function (r) {
    var t = r.querySelector('[data-x-rail-track]'), pv = r.querySelector('[data-x-rail-prev]'), nx = r.querySelector('[data-x-rail-next]');
    if (!t || !pv || !nx) return;
    var step = function () { var li = t.querySelector('li'); return li ? li.getBoundingClientRect().width + 14 : t.clientWidth * 0.8; };
    var upd = function () { pv.disabled = t.scrollLeft < 8; nx.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8; };
    pv.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: RM ? 'auto' : 'smooth' }); });
    nx.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: RM ? 'auto' : 'smooth' }); });
    t.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd); upd();
  });

  /* ---------- Feste Leiste mobil: nach dem Hero, nicht über dem Schluss-CTA/Fuß ---------- */
  var sticky = d.querySelector('[data-x-sticky]'), hero = d.querySelector('[data-x-hero]');
  if (sticky && hero && IO) {
    var fin = d.querySelector('[data-x-final]'), foot = d.querySelector('.site-footer');
    var vis = { hero: true, fin: false, foot: false };
    var upd = function () { var on = !vis.hero && !vis.fin && !vis.foot; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on)); var a = sticky.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1; };
    var o2 = new IntersectionObserver(function (es) { es.forEach(function (en) { vis[en.target === hero ? 'hero' : en.target === fin ? 'fin' : 'foot'] = en.isIntersecting; }); upd(); });
    o2.observe(hero); if (fin) o2.observe(fin); if (foot) o2.observe(foot);
  }

  /* ---------- Lichtkegel auf Kacheln (Richtung B, nur Maus) ---------- */
  if (!RM && window.matchMedia && matchMedia('(hover: hover)').matches) {
    d.addEventListener('pointermove', function (e) {
      if (de.getAttribute('data-design') !== 'b') return;
      var a = e.target.closest && e.target.closest('.x-tile__a'); if (!a) return;
      var r = a.getBoundingClientRect(); a.style.setProperty('--mx', (e.clientX - r.left) + 'px'); a.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  /* ---------- Produktseite (Sauna-Katalog): Angebot für Unternehmen + Einblenden ---------- */
  var prod = d.querySelector('[data-sk-product]');
  if (prod && 'MutationObserver' in window) {
    var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    var enhance = function () {
      var info = prod.querySelector('.product__info'); if (!info || info.querySelector('.x-pdp-b2b')) return;
      var a = d.createElement('a'); a.className = 'x-pdp-b2b'; a.href = '/pages/contact#unternehmen';
      var name = (prod.querySelector('.product__title') || {}).textContent || '';
      try { sessionStorage.setItem('pwx-b2b-produkt', name.replace(/\s+/g, ' ').trim() + ' – ' + location.href); } catch (e) {}
      a.innerHTML = '<span>' + (EN ? 'Quote for businesses' : 'Angebot für Unternehmen') + '<small>' + (EN ? 'Several saunas or a project? Request a personal quote.' : 'Mehrere Saunen oder ein Projekt? Persönliches Angebot anfragen.') + '</small></span>' + ARROW;
      var after = info.querySelector('[data-sk-consult]') || info.lastChild; after.parentNode.insertBefore(a, after.nextSibling);
      $$('.pdp-sections, .sk-related', prod).forEach(function (s) { s.classList.add('x-rv'); });
      reveal(prod);
    };
    new MutationObserver(function () { if (prod.querySelector('.kf-summary')) enhance(); }).observe(prod, { childList: true, subtree: true });
  }

  /* ---------- Kontaktformular: #unternehmen füllt die Nachricht vor (wird nicht abgeschickt) ---------- */
  if (location.hash === '#unternehmen') {
    var ta = d.querySelector('textarea[name="contact[body]"]');
    if (ta && !ta.value) {
      var prodLine = ''; try { prodLine = sessionStorage.getItem('pwx-b2b-produkt') || ''; } catch (e) {}
      ta.value = (EN ? 'Quote for businesses\nCompany:\nNumber of saunas / models:\nLocation:\nPreferred date:\n' : 'Angebot für Unternehmen\nFirma:\nAnzahl Saunen / Modelle:\nStandort:\nWunschtermin:\n') + (prodLine ? (EN ? 'Product: ' : 'Produkt: ') + prodLine + '\n' : '');
      setTimeout(function () { ta.scrollIntoView({ block: 'center', behavior: RM ? 'auto' : 'smooth' }); }, 200);
    }
  }
})();
